import React from 'react';
import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';

import { WttpTemplate } from 'src/graphql/generated/graphql';
import { getTableConfig } from './config';
import { WttpTemplateAction } from '../table/columns/actions/actions-modals';
import { PartialTemplateType } from 'src/components/wttp/templates/types';

type WttpTemplatesTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: PartialTemplateType[];
  onActionFinished?: (action: WttpTemplateAction) => void;
  isGlobalTemplatesOnly: boolean;
};

export const WttpTemplatesTable = ({
  className,
  data,
  options,
  onActionFinished,
  isGlobalTemplatesOnly,
  ...props
}: WttpTemplatesTableProps) => {
  const { t } = useTranslation();
  const tableConfig = getTableConfig((data || []) as WttpTemplate[], {
    t,
    onActionFinished,
    isGlobalTemplatesOnly,
  });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
